import { useEffect } from 'react';
import type { UseFiltersInstanceProps } from 'react-table';

import { SEARCH_FILTER_COLUMN_ID } from '@swf/poker';
import type { TableFilters, Tournament } from '@swf/poker';

const useTableSearchFilter = (
  filters: TableFilters,
  setFilter: UseFiltersInstanceProps<Tournament>['setFilter']
) => {
  const searchFilter = filters.find((filter) => filter.id === SEARCH_FILTER_COLUMN_ID)?.value;

  useEffect(() => {
    if (searchFilter) setFilter(SEARCH_FILTER_COLUMN_ID, searchFilter);
  }, [searchFilter, setFilter]);
};

export default useTableSearchFilter;
